import { useEffect, useRef, useState } from 'react';
import { useWallet } from '../context/WalletContext';
import { useContracts } from '../context/ContractContext';

export default function useRegistration(refreshFlag) {
  const { account, wrongNetwork } = useWallet();
  const { main } = useContracts();
  const [state, setState] = useState({ loading: true, registered: false, uid: '0' });
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    if (!account || wrongNetwork) {
      setState({ loading: false, registered: false, uid: '0' });
      return () => { mountedRef.current = false; };
    }
    setState((s) => ({ ...s, loading: true }));
    (async () => {
      try {
        const id = await main.addrToId(account);
        if (!mountedRef.current) return;
        const uidStr = id.toString();
        setState({ loading: false, registered: uidStr !== '0', uid: uidStr });
      } catch (_) {
        if (!mountedRef.current) return;
        setState({ loading: false, registered: false, uid: '0' });
      }
    })();
    return () => { mountedRef.current = false; };
  }, [account, main, wrongNetwork, refreshFlag]);

  return state;
}
